import { Component, EventEmitter, Input, Output } from '@angular/core';
import { REQUEST_DETAIL_CATEGORY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'request-detail-category-selector',
  templateUrl: './request-detail-category-selector.component.html',
  styleUrl: './request-detail-category-selector.component.scss',
  standalone: false,
})
export class RequestDetailCategorySelectorComponent {
  @Input() selectedCategory: string;
  @Output() categoryChange: EventEmitter<string> = new EventEmitter();
  REQUEST_DETAIL_CATEGORY = REQUEST_DETAIL_CATEGORY;

  categoryChangeHandler() {
    this.categoryChange.emit(this.selectedCategory);
  }
}
